<template>
  <div>
    <!-- Desktop Sidebar -->
    <aside
      class="h-[98vh] rounded-xl w-full xl:w-[304px] flex-col bg-[#020817] fixed 2xl:left-4 2xl:top-3 2xl:bottom-3 px-[22px] z-10"
    >
      <!-- Close Button (Only for Mobile) -->
      <button
        class="absolute top-4 right-4 sm:right-6 text-[#0099FF] hover:text-gray-400 block 2xl:hidden"
        @click="closeSidebar"
      >
        <XIcon />
      </button>

      <!-- Shining Border -->
      <div class="w-full mt-[81px] mb-[22px] flex justify-center">
        <img src="/Vector 6.svg" />
      </div>

      <NavigationContent
        :items="navigationItems"
        @closeSidebar="closeSidebar"
      />
    </aside>
  </div>
</template>

<script setup lang="ts">
import { ref, onMounted, onUnmounted, defineEmits } from "vue";
import {
  HomeIcon,
  ClockIcon,
  DiamondIcon,
  SettingsIcon,
  XIcon,
} from "lucide-vue-next";
import NavigationContent from "@/components/shared/NavigationContent.vue";

const isMobile = ref(window.innerWidth <= 768); // Detect mobile

// Emit event when sidebar is closed
const emit = defineEmits(["closeSidebar"]);
const closeSidebar = () => {
  emit("closeSidebar"); // Notify parent component
};

// Update mobile state on resize
const updateIsMobile = () => {
  isMobile.value = window.innerWidth <= 768;
};

onMounted(() => {
  window.addEventListener("resize", updateIsMobile);
});

onUnmounted(() => {
  window.removeEventListener("resize", updateIsMobile);
});

// Navigation items
const navigationItems = [
  {
    name: "HOME",
    icon: HomeIcon,
    href: "/",
    active: true,
  },
  {
    name: "HISTORY",
    icon: ClockIcon,
    href: "/history",
  },
  {
    name: "SCAN",
    icon: DiamondIcon,
    href: "/scan",
  },
  {
    name: "SETTINGS",
    icon: SettingsIcon,
    href: "/settings",
  },
];
</script>

<style scoped>
/* Sidebar gradient background */
aside,
.dark\:bg-background {
  background: linear-gradient(
    111.84deg,
    rgba(6, 11, 38, 0.94) 59.3%,
    rgba(26, 31, 55, 0) 100%
  );
}

/* Active link styling */
.router-link-active {
  background-color: #1a1f35;
}

/* Smooth transitions */
.router-link-active,
a {
  transition: all 0.2s ease-in-out;
}
</style>
